const conditions = () => {
  return [{ assetClass: { $ne: '' } }, { projectType: { $ne: '' } }, { fixedRentalPrice: 'object.fixed-rental.price.options.yes' }]
}

export default conditions
